import React, { useMemo } from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import useFiles from 'hooks/useFiles';
import { PATH_GET_FILES } from 'config';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

const resolveImageSrc = (item, getDownloadUrl) => {
  if (!item) return null;
  if (typeof item === 'string') return `${PATH_GET_FILES}/image/${item}`;
  if (item.fileId) return getDownloadUrl(item.fileId);
  if (item.image) return `${PATH_GET_FILES}/image/${item.image}`;
  if (item.url) return item.url;
  return null;
};

function ImagesSection({ section, data }) {
  const { colors, baseStyles } = useTemplateColors();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        container: {
          display: 'flex',
          flexDirection: 'column',
        },
        grid: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '0.3cm',
        },
        imageWrap: {
          width: '48%',
          border: `1px solid ${colors.border}`,
          padding: '0.15cm',
        },
        image: {
          width: '100%',
          height: '4cm',
          objectFit: 'contain',
        },
      }),
    [colors]
  );

  const { getDownloadUrl } = useFiles();
  const dataKey = section?.config?.dataKey || 'images';
  const items = Array.isArray(data?.[dataKey]) ? data[dataKey] : [];
  const sources = items.map((i) => resolveImageSrc(i, getDownloadUrl)).filter(Boolean);

  // Sin imágenes se omite el bloque entero (título incluido). Un documento que
  // se entrega al cliente no debe llevar una sección vacía ni un "Sin imágenes".
  if (sources.length === 0) return null;

  return (
    <View style={styles.container} wrap={false}>
      {section?.title ? <Text style={baseStyles.sectionTitle}>{section.title}</Text> : null}
      <View style={styles.grid}>
        {sources.map((src, idx) => (
          <View key={idx} style={styles.imageWrap}>
            <Image src={src} style={styles.image} />
          </View>
        ))}
      </View>
    </View>
  );
}

export default ImagesSection;
